import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ModalLoginComponent } from '../modal-login/modal-login.component';
import { ModalRegisterComponent } from '../modal-register/modal-register.component';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  year: number;
  rutaLogin: string;
  rutaRegister: string;

  constructor(private modalService: NgbModal, private router: Router) { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
    /*this.rutaLogin = this.router.url.split('#')[0]+'#login';
    this.rutaRegister = this.router.url.split('#')[0]+'#register'; */
    this.rutaLogin = this.router.url.split('#')[0];
    this.rutaRegister = this.router.url.split('#')[0]; 
  }
  openLogin() {    
    const modalRef = this.modalService.open(ModalLoginComponent, { 
      centered: true,  
      backdrop:'static'
    });  
    //modalRef.componentInstance.login = 104; // should be the id
  }

  openRegister() {    
    const modalRef = this.modalService.open(ModalRegisterComponent, { 
      centered: true,  
      backdrop:'static' 
    });
    modalRef.componentInstance.padre = 'footer';       
  }

}
